module.exports = __webpack_public_path__ + "static/media/27OCHA5.e0a8ec74.jpg";